import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// Sample Data - Update paths as needed
const COLLECTIONS = [
    {
        id: "chitra",
        label: "Chitra Sutram",
        heading: "Photo Embroidery",
        description: "Turn your memories into timeless thread art. Capturing emotions in a handcrafted frame.",
        mainImage: "images/carousel-21.webp",
        subImage: "images/carousel-23.webp",
        ctaLink: "#shop-chitra"
    },
    {
        id: "valaya",
        label: "Valaya Sutram",
        heading: "Hoop Embroidery",
        description: "Circular embroidery art crafted with detailed needlework. Elegant wall décor and gifting.",
        mainImage: "images/hoop2.webp",
        subImage: "images/hoop1.webp",
        ctaLink: "#shop-valaya"
    },
    {
        id: "accessories",
        label: "Accessories",
        heading: "Handcrafted Gems",
        description: "Brooches, keychains, and crochet pieces. Unique treasures to add personality to your style.",
        mainImage: "images/diary.webp",
        subImage: "images/acc2.webp",
        ctaLink: "#shop-access"
    }
];

export default function CollectionsSection() {
    const [activeTab, setActiveTab] = useState(0);
    const navigate = useNavigate();

    // Simplified Click Handler: No Timeouts, Instant Switch
    const handleTabClick = (index) => {
        setActiveTab(index);
    };

    const currentData = COLLECTIONS[activeTab];

    return (
        <section className="art-col-section">
            {/* Background Decorations (Scaled down visually via CSS) */}
            {/* Background Decorations: Themed Embroidery Items */}
            <div className="art-col-bg-decor" aria-hidden="true">
                {/* 1. Embroidery Hoop (Top Left - moving Right) */}
                <svg className="art-decor-item art-shape-1" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="2">
                    {/* Outer & Inner Circle */}
                    <circle cx="50" cy="55" r="40" />
                    <circle cx="50" cy="55" r="36" />
                    {/* Screw Mechanism */}
                    <rect x="42" y="5" width="16" height="10" rx="2" fill="currentColor" opacity="0.3" />
                    <rect x="48" y="2" width="4" height="6" fill="currentColor" />
                </svg>

                {/* 2. Thread Spool (Bottom Left - moving Right) */}
                <svg className="art-decor-item art-shape-2" viewBox="0 0 60 80" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M10,10 L50,10 L50,70 L10,70 Z" fill="currentColor" opacity="0.1" />
                    <path d="M10,10 L10,70 M50,10 L50,70" strokeWidth="3" />
                    <rect x="5" y="5" width="50" height="5" fill="currentColor" />
                    <rect x="5" y="70" width="50" height="5" fill="currentColor" />
                    {/* Threads */}
                    <line x1="10" y1="20" x2="50" y2="25" strokeWidth="1" opacity="0.5" />
                    <line x1="10" y1="30" x2="50" y2="35" strokeWidth="1" opacity="0.5" />
                    <line x1="10" y1="40" x2="50" y2="45" strokeWidth="1" opacity="0.5" />
                </svg>

                {/* 3. Button (Top Right - moving Left) */}
                <svg className="art-decor-item art-shape-3" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="50" cy="50" r="40" fill="currentColor" opacity="0.1" />
                    <circle cx="50" cy="50" r="40" strokeWidth="2" />
                    <circle cx="50" cy="50" r="32" strokeWidth="1" opacity="0.5" />
                    {/* Holes */}
                    <circle cx="38" cy="38" r="4" fill="currentColor" />
                    <circle cx="62" cy="38" r="4" fill="currentColor" />
                    <circle cx="38" cy="62" r="4" fill="currentColor" />
                    <circle cx="62" cy="62" r="4" fill="currentColor" />
                </svg>

                {/* 4. Needle (Bottom Center - moving Right) */}
                <svg className="art-decor-item art-shape-4" viewBox="0 0 100 100" fill="currentColor">
                    <path d="M85,10 C88,13 88,18 85,21 L20,86 C15,91 5,95 5,95 C5,95 9,85 14,80 L79,15 C82,12 85,10 85,10 Z M82,16 L78,20 L80,22 L84,18 L82,16 Z" opacity="0.6" />
                    {/* Eye hole */}
                    <path d="M78 14 L86 22" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
                </svg>

                {/* 5. Keychain/Charm (Top Right - moving Left) */}
                <svg className="art-decor-item art-shape-5" viewBox="0 0 60 80" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="30" cy="15" r="10" />
                    <line x1="30" y1="25" x2="30" y2="35" />
                    {/* Charm Shape (Heart-ish) */}
                    <path d="M30,35 C15,25 5,40 30,70 C55,40 45,25 30,35" fill="currentColor" opacity="0.2" />
                    <path d="M30,35 C15,25 5,40 30,70 C55,40 45,25 30,35" strokeLinejoin="round" />
                </svg>
            </div>

            <div className="art-col-container">

                {/* Header & Tabs */}
                <div className="art-col-header">
                    <h2 className="art-col-main-title">Our Collection</h2>
                    <div className="art-col-tabs">
                        {COLLECTIONS.map((item, index) => (
                            <button
                                key={item.id}
                                onClick={() => handleTabClick(index)}
                                className={`art-col-tab-btn ${activeTab === index ? "active" : ""}`}
                            >
                                {item.label}
                            </button>
                        ))}
                    </div>
                </div>

                {/* KEY CONCEPT: By adding key={activeTab}, React destroys the old grid 
           and creates a new one instantly when the tab changes. 
           This re-triggers the CSS entry animation immediately.
        */}
                <div className="art-col-grid" key={activeTab}>

                    {/* 1. Text Card */}
                    <div className="art-col-item text-card">
                        <div className="art-col-text-inner">
                            <h3 className="art-col-card-title">{currentData.heading}</h3>
                            <p className="art-col-card-desc">{currentData.description}</p>
                            <button className="art-col-see-more" onClick={() => navigate('/collection')}>See More</button>
                        </div>
                    </div>

                    {/* 2. Sub Image (Bottom Left) */}
                    <div className="art-col-item sub-img-card">
                        <img
                            src={currentData.subImage}
                            alt={`${currentData.heading} Detail`}
                            className="art-col-img"
                            loading="lazy"
                        />
                    </div>

                    {/* 3. Main Image (Right Side) */}
                    <div className="art-col-item main-img-card">
                        <img
                            src={currentData.mainImage}
                            alt={currentData.heading}
                            className="art-col-img"
                            loading="lazy"
                        />
                    </div>

                    {/* 4. Central Badge */}
                    <div className="art-col-badge">
                        <a href={currentData.ctaLink} className="art-col-badge-inner">
                            <span>SHOP</span>
                            <span>NOW</span>
                        </a>
                    </div>

                </div>
            </div>
        </section>
    );
}